
<template>  
  <v-layout row wrap class="pa-5">  
    <v-dialog v-model="dialog" max-width="1000px" class="v-dialog__size">
        <template v-slot:activator="{ on }" >
            <v-btn color="primary" dark class="mb-2" @click="createNewActivity()" >New Activity</v-btn>
        </template>
        <v-card >
            <v-card-title>
            <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text class="v-card__text" >
                <v-container grid-list-md>
                    <v-layout wrap>        
                      <v-flex xs12 sm6 md3>                              
                          <DatePicker picker-label="Created Date" :is-disabled="true" :date-value="editedItem.createDate" /> 
                      </v-flex> 
                      <v-flex xs12 sm6 md3>
                            <v-combobox
                            :items="typeList"
                            label="Select Type"
                            v-model="editedItem.type"
                            item-text="text"
                            single-line
                            return-object
                            ></v-combobox>
                        </v-flex> 
                      <v-flex xs12 sm6 md3>                              
                          <DatePicker picker-label="Activity Date" :date-value="editedItem.activityDate" @dateSelected="editedItem.activityDate=$event" /> 
                      </v-flex> 
                      <v-flex xs12 sm6 md3>                              
                          <TimePicker picker-label="Activity Time" :time-value="editedItem.activityTime" @dateSelected="editedItem.activityTime=$event" /> 
                      </v-flex>         
                      <v-flex xs12 sm6 md4>
                          <v-combobox
                            :items="personnelsList"
                            label="Select Personnels"
                            v-model="editedItem.personnels"
                            item-text="name"
                            multiple
                            chips
                            return-object
                          >
                            <template slot="item" slot-scope="data">
                              {{ data.item.name }}  {{ data.item.surname }}
                            </template>
                          </v-combobox>
                        </v-flex> 
                        <v-flex xs12 sm6 md2>
                          <v-switch
                            v-model="editedItem.reminder"
                            label="Reminder"
                          ></v-switch>
                        </v-flex> 
                        <v-flex xs12 sm6 md3>                              
                            <DatePicker
                            v-if="editedItem.reminder && editedItem.reminder ==1"
                             picker-label="Remind Date" :date-value="editedItem.remindDate" @dateSelected="editedItem.remindDate=$event" /> 
                        </v-flex>                                         
                        <v-flex xs12 sm6 md3>                              
                          <TimePicker 
                          v-if="editedItem.reminder && editedItem.reminder ==1"
                          picker-label="Reminder Time" :time-value="editedItem.remindTime" @dateSelected="editedItem.remindTime=$event" /> 
                      </v-flex>    
                        <v-flex xs12 sm6 md12>
                            <v-text-field v-model="editedItem.header" label="Header"></v-text-field>
                        </v-flex> 
                        <v-flex xs12 sm6 md12>
                            <v-textarea v-model="editedItem.explanation"  :outlined="true"
                            :auto-grow="true" :clearable="true"
                            label="Explanation"></v-textarea>
                        </v-flex>            
                        <v-flex xs12 >
                            <Documents v-if="editedItem.id>0" :documents="editedItem.documents" master-category="ACTIVITY" :folder-id="currentCustomer.folderId"
                                       :parentRecord="editedItem.id" :readonly="false" @documentsChanged="getCustomerActivities" />
                        </v-flex>                                                                                                                                                             
                    </v-layout>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
            <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-flex xs12>
        <v-timeline
        :align-top="alignTop"
        :dense="dense"
        :reverse="reverse"
      >
        <v-timeline-item
          v-for='item in this.customerActivitiesComputed'
          :key="item.id"
          :fill-dot="fillDot"
          :hide-dot="hideDot"
          :icon=" icon ?  item.type.icon  : '' "
          :icon-color=" iconColor ? 'deep-orange' : ''"
          :left="left"
          :right="right"
          :small="small"
        >
          <template v-slot:icon>
            <v-badge
              v-if="item.reminder && item.reminder==1"
              bordered
              :color="getReminderColor(item)"
              icon="mdi-bell"
            >
              <v-icon                  
                @click="editItem(item)">
                {{item.type.icon}}
             </v-icon> 
            </v-badge>
            <v-icon              
              v-if="!item.reminder || item.reminder==0"    
                @click="editItem(item)">
                {{item.type.icon}}
             </v-icon> 
          </template>
          <span slot="opposite">{{item.activityDate}}</span>
          <v-card class="elevation-2">
            <v-card-title class="headline"><a  @click.prevent="editItem(item)"  >{{item.header}}</a></v-card-title>
            <v-card-text>
              {{item.explanation.substring(0, 300)}}
            </v-card-text>
            <v-card-actions>
                <v-col class="text-right">
                    <v-icon                
                        @click="deleteItem(item)">
                        mdi-close-circle
                    </v-icon> 
                </v-col>        
            </v-card-actions>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </v-flex>
  </v-layout>
</template>

<script>
import DatePicker from '../components/DatePicker';
import TimePicker from '../components/TimePicker';
import getCurrentDate from '../helpers/getCurrentDate';
import Documents from '../views/Documents';

const CUSTOMER_ACTIVITIES_API_URL = 'definitions/customerActivities';
const CUSTOMER_ACTIVITY_TYPES_API_URL = 'definitions/customerActivityTypes';
const CUSTOMER_API_URL = 'definitions/customers/';
const PERSONNELS_URL = 'definitions/personnelReduced/status/'

export default {
  name: 'CustomerTimeline',
  components: {
      DatePicker,
      TimePicker,
      Documents
  },
  props: {
    currentCustomer : {}
  },
  data: () => ({
    dialog: false,
    alignTop: false,
    avatar: false,
    dense: false,
    fillDot: true,
    hideDot: false,
    icon: true,
    iconColor: true,
    left: false,
    reverse: false,
    right: false,
    small: false,
    
    editedIndex: -1,
    editedItem: {},
    defaultItem: {},

    customerActivities: [],
    personnelsList: [],
    typeList: [],
    
    }),
  watch: {
  },
  created() {    
    this.getCustomerActivities();
    this.getPersonnels();
    this.getTypes();
  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Activity' : 'Edit Activity'
    },
    customerActivitiesComputed(){
      return this.customerActivities.map((item) => {
        item.activityTime= item.activityDate.split('T')[1];
        item.activityDate= item.activityDate.split('T')[0] ;
        item.remindTime= item.remindDate ? item.remindDate.split('T')[1] : '';
        item.remindDate= item.remindDate ? item.remindDate.split('T')[0] : '';
        return item;  
      });
    },
  },
  methods: {
    createNewActivity(){
      let loggedInUser = localStorage.getItem('user_id');
      if( loggedInUser ){
        let filteredPersonnel = this.personnelsList.filter(x => x.user && ( x.user.id == loggedInUser));
        if( filteredPersonnel && filteredPersonnel.length>0 ){
          if(this.editItem){
            this.editedItem.personnels = filteredPersonnel;
          }  
        }
      }
      this.dialog = true;
    },
    editItem (item) {      
      this.editedIndex = this.customerActivities.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    getReminderColor (item) {
      if(!item) return ''
      else if (new Date(item.remindDate) < Date.now()) return 'red'
      else if (Date.now()< new Date(item.remindDate) ) return 'orange'
      else return 'red'
    },
    deleteItem (item) {
      const index = this.customerActivities.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.customerActivities.splice(index, 1);
        this.deleteActivity(item);
      } 
    },
    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    getCustomerActivities(){
        this.$axios.get(this.$apiurl + CUSTOMER_API_URL+this.$route.params.id+'/activities')
        .then(response => {
            this.customerActivities = response.data;
        }) 
        .catch(error => {
            console.log(error);
        });   
    },
    getPersonnels(){     
        this.$axios.get(this.$apiurl + PERSONNELS_URL + true)
            .then(response => {
                this.personnelsList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    save () {

      if(!this.editedItem.activityDate){
        alert('Activity Date cannot be empty!');
        return;
      }  

      if(this.editedItem.reminder){

        if(!this.editedItem.personnels || this.editedItem.personnels.length ==0){
          alert('To set reminder please select at least one personnel!');
          return;
        } 

        if(this.editedItem.remindTime ){
          if(!this.editedItem.remindDate){
            alert('Remind Date cannot be empty!');
            return;
          }
        }
        
        if(!this.editedItem.remindDate){
          alert('Remind Date cannot be empty!');
          return;
        }  

        if(this.editedItem.remindDate > this.editedItem.activityDate){
          alert('Remind Date cannot be after Activity Date!');
          return;
        } 
      }

      if(!this.editedItem.header){
        alert('Header cannot be empty!');
        return;
      }     
      if(!this.editedItem.explanation){
        alert('Explanation cannot be empty!');
        return;
      }   
      if(!this.editedItem.type){
        alert('Type cannot be empty!');
        return;
      } 

      if (this.editedIndex > -1) {        
        this.updateActivity(this.editedItem);
      } else {
        this.addActivity(this.editedItem);         
      }      
    },
    addActivity(item){      
      this.$axios.post(this.$apiurl + CUSTOMER_ACTIVITIES_API_URL, {
        customerId: this.$route.params.id,
        typeId: item.type.id,
        header: item.header,
        activityDate: item.activityTime  ? ( item.activityDate +"T"+ item.activityTime) : item.activityDate +"T"+ "00:00", 
        remindDate: item.reminder ? (item.remindTime ? (item.remindDate +"T"+ item.remindTime) : (item.remindDate+"T"+ "00:00")) : null,
        reminder : item.reminder ? 1 : 0,
        personnels : item.personnels ? Array.from(item.personnels,x => x.id) : null,
        explanation: item.explanation
      })
      .then(response => {        
        if (response.status === 201) {
          item.id = response.data;
          this.getCustomerActivities();
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateActivity(item){

      let that = this;
      this.$axios.put(this.$apiurl + CUSTOMER_ACTIVITIES_API_URL, {
        id: item.id,
        customerId: this.$route.params.id,
        typeId: item.type.id,
        header: item.header,
        activityDate: item.activityTime  ? ( item.activityDate +"T"+ item.activityTime) : item.activityDate +"T"+ "00:00", 
        remindDate: item.reminder ? (item.remindTime ? (item.remindDate +"T"+ item.remindTime) : (item.remindDate+"T"+ "00:00")) : null,
        reminder : item.reminder ? 1 : 0,
        personnels : item.personnels ? Array.from(item.personnels,x => x.id) : null,
        explanation: item.explanation
      })
      .then(response => {
        if (response.status === 200) {
          this.getCustomerActivities();
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    deleteActivity(item){
      this.$axios.delete(this.$apiurl + CUSTOMER_ACTIVITIES_API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },  
    getTypes(){     
        this.$axios.get(this.$apiurl + CUSTOMER_ACTIVITY_TYPES_API_URL)
            .then(response => {
                this.typeList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
  }
}
</script>
<style scoped>
  .v-dialog__size{
    min-height: 505px;
      overflow:auto;
      padding: 5px;
  }
  .v-card__text {
    max-height: 655px;
      overflow:auto;
      padding: 5px;
  }
  .v-card__action{
    padding: 1px;
  }
  .text-right{
    padding: 3px;
  }
</style>